export const phoneRegex = /0 \(\d{3}\) \d{3} \d{4}$/
